import * as React from "react";
import LandingPage from "./LandingPage";

const SoftwareTraining = () => {
 

  return  (
      
      <LandingPage></LandingPage>
    
  );
  
};
export default SoftwareTraining;
